import { Component, Input } from '@angular/core';
import { IZorroInsightData } from '../../models/zorro-insight-data.model';

@Component({
  selector: 'app-insight-table',
  templateUrl: './insight-table.component.html',
  styleUrl: './insight-table.component.scss'
})
export class InsightTableComponent {
  @Input() title!: string;
  @Input() meter: IZorroInsightData = {
    columns: [],
    data: []
  };
  @Input() colSpan: number = 0;
  @Input() showMeta: boolean = false;
}
